module.exports = __webpack_public_path__ + "img/CM-KT-24-Mazda-Established.3119fa3c.jpg";